/**
 * External dependencies
 */
import React from "react";

/**
 * Configuration
 */
import config from "../config";
const { texts } = config;

const ErrorMessage = () => {
	const { title, text } = texts?.error_message || {
		title: "Error loading data.",
		text: "Please try again later.",
	};

	return (
		<div className="error-message">
			<h3>{title}</h3>
			{!!text && <p>{text}</p>}
		</div>
	);
};

export default ErrorMessage;
